import { Alert, Heading } from '@mm/components';
import { useAdAudienceCRUDActions } from '@mm/state/actions/AdAudienceCRUDActions';
import { useAudiencesCRUDActions } from '@mm/state/actions/AudiencesCRUDActions';
import AudiencesModel from '@mm/state/model/AudiencesModel';
import { selectActiveAdAccount } from '@mm/state/selectors/adAccountsSelecotrs';
import { selectFacebookAdAudiences } from '@mm/state/selectors/adAudiencesSelector';
import { selectAudiences } from '@mm/state/selectors/messengerAdSelectors';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { AdAudienceSelect } from '@mm/stateful-components/AdAudienceSelect/AdAudienceSelect';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AudienceSelector } from '../../../../features/campaigns/components/AudienceSelector/AudienceSelector';
import styles from './FacebookAdsAudienceMapping.module.css';

type Props = {
  className?: string;
  chatbotId: number;
  selectedAudienceId?: number | null;
  selectedAdAudienceId?: number | null;
  onAudienceChange: (audienceId: number) => void;
  onAdAudienceChange?: (adAudienceId: number) => void;
  onCancel?: () => void;
};

export const FacebookAdsAudienceMapping = ({
  className,
  selectedAudienceId,
  selectedAdAudienceId,
  onAudienceChange = () => {},
  onAdAudienceChange = () => {},
  chatbotId,
  onCancel,
}: Props) => {
  const facebookPageId = useSelector(activeFacebookPageIdSelector);
  const activeAdAccount = useSelector(selectActiveAdAccount);

  const audiences = useSelector(selectAudiences);
  const adAudiences = useSelector(selectFacebookAdAudiences);

  const audiencesCRUDActions = useAudiencesCRUDActions();
  const adAudienceCRUDActions = useAdAudienceCRUDActions();

  const selectedAudience =
    audiences &&
    audiences.find((a: AudiencesModel) => a.id === selectedAudienceId);

  useEffect(() => {
    if (!audiences.length) {
      audiencesCRUDActions.retrieveAll(chatbotId);
    }

    if (!adAudiences.length && activeAdAccount) {
      adAudienceCRUDActions.retrieveAll(facebookPageId, activeAdAccount.id);
    }
  }, [activeAdAccount?.id, chatbotId, facebookPageId]);

  return (
    <div className={classNames(className, styles.container)}>
      <div className={styles.field}>
        <Heading size={5}>Audience</Heading>
        <AudienceSelector
          autoselect={false}
          selectedAudienceId={selectedAudience?.id}
          onAudienceSelected={audience => onAudienceChange(audience)}
          onCancel={onCancel}
          emphasizeAllContactsForRestore
        />
      </div>

      <div className={classNames(styles.field, styles.hidden)}>
        <Heading size={5}>Facebook Audience</Heading>
        <AdAudienceSelect
          disabled={true}
          selectedAdAudienceId={selectedAdAudienceId}
          onChange={audience => onAdAudienceChange(audience)}
        />

        {!selectedAdAudienceId && (
          <Alert type="info" showCloseIcon={false} className={styles.alert}>
            New Facebook Audience will be created
          </Alert>
        )}
      </div>
    </div>
  );
};
